<div
  @tooltip
  class="text-xs py-2.5 px-3 rounded-lg tooltip-box-shadow max-w-72 bg-[--tooltip-bg-color] text-[--tooltip-text-color] {{
    className
  }}"
  data-tooltip
  data-testid="tooltip-box"
>
  @if (isSimpleType) {
    {{ text }}
  } @else {
    <ng-template [ngTemplateOutlet]="$any(text)"></ng-template>
  }
</div>
